import BlockMessage from './BlockMessage';

export default BlockMessage;
